import { useEffect, useState } from "react";
import {  Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import orgJson from "components/jsonData/orgnization.json";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { AiFillDelete } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import { getSeletedSalesModuleIcon } from "../expenseModule/moduleIcon";
import { FaEye, FaPlusCircle } from "react-icons/fa";
import InvoiceModuleForm from "./invoiceModuleForm";
import { fetchAsyncGetSalesInvoiceModule } from "redux/salesInvoiceModuleSlice";
import { fetchAsyncDeleteSalesInvoiceModule } from "redux/salesInvoiceModuleSlice";
import { SettingOutlined } from "@ant-design/icons";
import PaymentTerms from "./paymentTerms";
import SalesInvoicePdf from "components/allForm/SalesInvoiceForm/ExportSalesOrder/salesInvoicePdf";

const {
  Box,
  Button,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Tooltip,
} = require("@chakra-ui/react");

const OrganizationSalesInvoiceType = () => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [invoiceView,setInvoiceView] = useState(false)
  const [moduleId,setModuleId] = useState("")
  
  const salesModule = useSelector((state) => state.salesModule);

  const getSalesInvoiceType = ()=>{
    dispatch(fetchAsyncGetSalesInvoiceModule())
  }
  useEffect(()=>{
    getSalesInvoiceType();
  },[])

  const handleClose = ()=>{
    setIsOpen(false);
    setIsEdit(false);
    setEditData("");
    getSalesInvoiceType()
  }
  const handleCloseSetting = ()=>{
    setIsSetting(false);
    setIsEdit(false);
    setEditData("");
    getSalesInvoiceType()
  }

 
  const handleDeleteModule = async (e, item) => {
    e.preventDefault();
    const confirmationMessage = orgJson.confirm.deleteModule;
    const title = confirmationMessage.replace("{itemName}", item?.name);
    ConfirmationDialog({
      title: title,
      text: orgJson.text.undone,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        dispatch(fetchAsyncDeleteSalesInvoiceModule(item?._id))
          .then((res) => {
            if (res?.payload) {
              getSalesInvoiceType()
              addToast("Module Deleted Successfully!", {
                appearance: "success",
              });
            } else {
              addToast(res?.error?.message, { appearance: "error" });
            }
          })
          .catch((err) => {
            addToast("An error occurred. Please try again.", {
              appearance: "error",
            });
          });
      },
    });
  };

  const handleEditClick = (e, data) => {
    e.preventDefault();
    setIsEdit(true);
    setEditData(data);
    setIsOpen(true)
  };
  const handleView = (e,item)=>{
    e.preventDefault();
    setModuleId(item?._id)
    setInvoiceView(true);
  }

  const handleSettingClick = (e, data) => {
    e.preventDefault();
    setIsEdit(true);
    setEditData(data);
    setIsSetting(true)
  };

  return (
    <>
      <Form className="addForm m-3 mt-5">
        <div className="form-card">
            <Box display="flex">
          <h5 className="mt-">Sales Invoice Module</h5>
          <Button className="mt-0 add-user-btn" onClick={() => setIsOpen(true)}>
            <FaPlusCircle className="add-project-icon" size={15} />
          </Button>
            </Box>
         
        </div>
      </Form>
      <div className="module-table">
        <Table className="field-table">
          <Thead>
            <Tr>
              <Th className="number">No.</Th>
              <Th className="module-name">Module Name</Th>
              <Th className="prifix">Prifix</Th>
              <Th className="chart-color">Chart Color</Th>
              <Th className="chart-icon">Icon</Th>
              <Th className="chart-action">Action</Th>
              <Th className="chart-icon module-setting">-</Th>
            </Tr>
          </Thead>
          <Tbody>
            {salesModule && salesModule.length
              ? salesModule.map((item, index) => {
                  return (
                    <>
                    <Tr>
                      <Td className="number">{index + 1}</Td>
                      <Td className="module-name">{item.name}</Td>
                      <Td className="prifix">
                        {item.prfx} , {item.pfPrfx}
                      </Td>
                      <Td className="chart-color chart-data">
                        <input type="color" disabled value={item.clr} />
                      </Td>
                      <Td className="chart-icon">
                        {item?.icnImg && getSeletedSalesModuleIcon(item.icnImg)
                          ? getSeletedSalesModuleIcon(item.icnImg)
                          : "-"}
                      </Td>
                      
                      <Td className="chart-action">
                        <div className="d-flex mx-1">
                          <MdModeEdit
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              handleEditClick(e, item);
                            }}
                          />
                          <FaEye
                            title="Invoice Template"
                            size={16}
                            style={{ cursor: "pointer",color:"blue",marginLeft: "7px",
                            }}
                            onClick={(e) => handleView(e,item)}
                          />
                          <AiFillDelete
                            style={{
                              cursor: "pointer",
                              color: "#c3473e",
                              marginLeft: "7px",
                            }}
                            size={16}
                            onClick={(e) => {
                              handleDeleteModule(e, item);
                            }}
                          />
                        </div>
                      </Td>
                      <Td className="chart-icon module-setting">
                        <Tooltip
                        label="Settings"
                        placement="top"
                        hasArrow
                        className="common-tooltip"
                        >
                        <SettingOutlined size={20} onClick={(e)=>handleSettingClick(e,item)}/>
                        </Tooltip>
                      </Td>
                     
                    
                    </Tr>
                    </>
                  );
                })
              : ""}
          </Tbody>
        </Table>
      </div>
      {isOpen && (
          <InvoiceModuleForm
            isOpen={isOpen}
            onClose={handleClose}
            isEdit={isEdit}
            editData={editData}
          />
        )}
        {isSetting && (
          <PaymentTerms
            isOpen={isSetting}
            onClose={handleCloseSetting}
            isEdit={isEdit}
            editData={editData}
          />
        )}
         {invoiceView && (
          <SalesInvoicePdf
            isOpen={invoiceView}
            onClose={() => {
              setInvoiceView(!invoiceView);
              setModuleId("")
            }}
            isProforma={false}
            expenseData={{inNo:{prfx:'INV-',n:'00'}}}
            itemList={[
              {
                slItm: {
                  name:"Test Service in INR for client 2",
                  dc:"The rate at which you're going to sell this item.",
                  sCd : "111111"
                },
                qty: 2,
                prc: 1000,
                tax: {},
                amt: 2000,
              },
            ]}
            moduleId={moduleId}
            isPreview={true}
          />
        )}
    </>
  );
};

export default OrganizationSalesInvoiceType;
